import {
    REMOVE_REVIEW_IMAGE_ERROR,
    REMOVE_REVIEW_IMAGE_START,
    REMOVE_REVIEW_IMAGE_SUCCESS
} from '../constants';
import { removeReviewImage as mutation, getOrder as query } from '../lib/graphql';

export function removeReviewImage(id, picture) {
    return async function (dispatch, getState, { client }) {
        try {
            dispatch({
                type: REMOVE_REVIEW_IMAGE_START
            })
            const { data } = await client.mutate({
                mutation,
                variables: {
                    orderId: id,
                    picture
                },
                refetchQueries: [{ query }]
            })
            if (data?.removeReviewImage?.status === 200) {
                dispatch({
                    type: REMOVE_REVIEW_IMAGE_SUCCESS
                });
            } else {
                dispatch({
                    type: REMOVE_REVIEW_IMAGE_ERROR
                })
            }

        }
        catch (err) {
            dispatch({
                type: REMOVE_REVIEW_IMAGE_ERROR
            })

        }
    }
}